import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import Modal from "react-modal"

import Button from "components/common/Button"

import ErrorIcon from "assets/icons/error.svg"
import SuccessIcon from "assets/icons/success.svg"
import WarningIcon from "assets/icons/warning.svg"

import "styles/components/common/response-modal.scss"

const iconTypes = {
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
}
class ConfirmModal extends Component {
  constructor() {
    super()

    this.state = {
      fieldErrors: {},
    }
  }

  render() {
    const {
      isOpen,
      modalContent = {},
      closeModal,
      onConfirm,
      onCancel,
    } = this.props

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        className="response-modal"
        overlayClassName="response-modal-overlay"
      >
        <Fragment>
          <div className="response-modal-container">
            <span className="response-modal-icon">
              <img src={iconTypes[modalContent.modalType]} alt="SUCCESS" />
            </span>
            {modalContent.header && (
              <span
                className={`response-modal-header ${modalContent.modalType}`}
              >
                {modalContent.header}
              </span>
            )}
            <p className="response-modal-message">{modalContent.message}</p>
            <div className="button-group">
              <Button
                label={modalContent.confirmLabel || "Confirm"}
                onClick={onConfirm}
              />
              <Button
                label={modalContent.cancelLabel || "Cancel"}
                ghost={true}
                customClassName="mt-s"
                onClick={onCancel || closeModal}
              />
            </div>
          </div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(ConfirmModal)
